<template>
  <div class="carList full-height linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
    >
      车型列表
    </ld-header>
    <div class="pad-lr-6">
      <div class="carListwrapper">
        <mescroll-vue
          ref="mescroll"
          :down="down"
        >
          <div>
            <div
              v-if="carSearchInfo.useType==4"
              class="bg-white"
            >
              <van-row
                type="flex"
                align="center"
              >
                <van-col
                  span="3"
                  class="text-center"
                >
                  <img
                    width="26"
                    :src="carSearchInfo.scimg"
                    alt="."
                    class="vertical-bottom"
                  >
                </van-col>
                <van-col span="21">
                  <van-cell
                    class="van-hairline--bottom"
                    :title="`${carSearchInfo.scdd}`"
                    :label="carSearchInfo.scaddress"
                  />
                </van-col>
              </van-row>
            </div>
            <div
              v-else
              class="bg-white"
            >
              <van-row
                type="flex"
                align="center"
              >
                <van-col
                  span="3"
                  class="text-center"
                >
                  <img
                    width="26"
                    :src="carSearchInfo.scimg"
                    alt="."
                    class="vertical-bottom"
                  >
                </van-col>
                <van-col span="21">
                  <van-cell
                    class="van-hairline--bottom"
                    :title="`${carSearchInfo.useType==0?(carSearchInfo.departCityName+' '+carSearchInfo.scdd):carSearchInfo.scdd}`"
                    :label="carSearchInfo.useType==0?carSearchInfo.desc:carSearchInfo.scaddress"
                    :placeholder="$t('Q002','航站楼')"
                  />
                </van-col>
              </van-row>
              <van-row
                type="flex"
                align="center"
              >
                <van-col
                  span="3"
                  class="text-center"
                >
                  <img
                    width="26"
                    :src="carSearchInfo.xcimg"
                    alt=""
                    class=" vertical-bottom"
                  >
                </van-col>
                <van-col span="21">
                  <van-cell
                    :title="`${carSearchInfo.useType==1?((carSearchInfo.arriveCityName)+' '+carSearchInfo.xcdd + ' '+(carSearchInfo.departTerminal || '')):carSearchInfo.xcdd}`"
                    :label="carSearchInfo.xcaddress"
                    :placeholder="$t('Q002','航站楼')"
                  />
                </van-col>
              </van-row>
            </div>


            <transition-group
              tag="div"
              name="van-slide-right"
            >
              <div
                v-for="(info, index) in list"
                :key="info.vehicleTypeName"
                class="box"
                @click="check(index)"
              >
                <van-card
                  :thumb="info.coverUrl"
                  class="round-sm"
                >
                  <div slot="title">
                    <span class="font16 font-lg">{{ info.vehicleTypeName }}</span>
                    <span class="fr">
                      <span class="money-color font10">￥</span>
                      <span class="money-color font16 font-lg">{{ info.detailBeanList[0].salePrice }} </span>
                      <span class="gray font10">起</span>
                    </span>
                  </div>
                  <div
                    slot="desc"
                    class="pad-tb-5"
                  >
                    <ld-icon class="iconfont iconchangyongicon-" />×{{ info.luggageNum }}
                    &nbsp;
                    <ld-icon class="iconfont icongerentouxiang_o" />×{{ info.personNum }}
                  </div>
                  <div
                    slot="tags"
                    class="gray"
                  >
                    {{ info.vehicleTypeDesc }}
                  </div>
                  <div
                    slot="footer"
                    v-show="info.checked"
                    class="van-hairline--top"
                  >
                    <van-row
                      type="flex"
                      align="center"
                      justify="space-between"
                      class="p-t-15"
                      v-for="pd in info.detailBeanList"
                      :key="pd.productId"
                    >
                      <van-col
                        span="12"
                        class="text-left"
                      >
                        <img
                          class="round-sm vertical-middle"
                          width="24"
                          :src="pd.priceFromUrl"
                        >
                        &nbsp;
                        <span class="font14">{{ pd.priceFromName }}</span>
                      </van-col>
                      <van-col span="3">
                        <van-tag
                          v-show="iswb(pd)"
                          type="danger"
                        >
                          {{ $t('K303','违') }}
                        </van-tag>
                      </van-col>
                      <van-col
                        span="4"
                        class="text-center money-color font14"
                      >
                        ￥{{ pd.salePrice }}
                      </van-col>
                      <van-col span="5">
                        <ld-button
                          size="md"
                          :main="canbook(pd)"
                          :gray="!canbook(pd)"
                          @click.stop="canbook(pd) && book(info, pd)"
                        >
                          {{ $t('B003','预订') }}
                        </ld-button>
                      </van-col>
                    </van-row>
                  </div>
                </van-card>
              </div>
            </transition-group>

            <ld-no-more />
            <div class="boxfromStorn" />
          </div>

          <ld-call-service
            style=""
            class="zhuanshukefu"
            name="van-fade"
            v-if="
              loginConfig &&
                loginConfig.pageName &&
                loginConfig.pageName.indexOf('柒个贰') > -1
            "
            from="10906"
          />
        </mescroll-vue>
      </div>
    </div>
    <violate-list
      cplx="10906"
      ref="violateList"
      :violate="clzcStr"
      @selected="() => book()"
    />
  </div>
</template>

<script>
import { Card, Divider, Field, Button, Cell, Tag ,Tab, Tabs, Image as VanImage, Lazyload } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldNoMore from 'Common/ldNoMore'
import { mapGetters } from 'vuex'
import ldButton from 'Common/ldButton'
import violateList from 'Components/violateList'
import mixin from './mixin'
import ldCallService from 'Components/ldCallService'

export default {
  name: 'CarList',
  mixins: [mixin],
  components: {
    MescrollVue,
    [Card.name]: Card,
    [Cell.name]: Cell,
    [Divider.name]: Divider,
    [Field.name]: Field,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [VanImage.name]: VanImage,
    [Lazyload.name]: Lazyload,
    ldNoMore,
    ldButton,
    violateList,
    ldCallService
  },
  data() {
    return {
      down: { use:false },
      clzcStr: '',
      list: [],
      detailBeanList: [],
      detailBean: {},
      cacheId:'',
    }
  },
  computed: {
    ...mapGetters({
      carSearchInfo:'car/carSearchInfo',
      carList:'car/carList',
      travelerList: 'car/travelerList',
      tripType: 'tripType',
      userInfo:'userInfo',
      pageCtrl: 'serviceCtrl', //页面控制信息
      loginConfig: 'loginConfig',
    }),
  },
  created() {

    this.search(this.carSearchInfo)
    // if(this.carList.length==0){
    // 	this.search(this.carSearchInfo)
    // }else{
    // 	this.list=this.carList
    // }
  },
  methods: {
    //查询
    search(info) {
      console.log('info:' , info)
      console.log('travelerList[0]:' , this.travelerList[0])
      info.sclocation = info.sclocation || {}
      info.xclocation = info.xclocation || {}

      let arr = [
        {
          useAirportOrZd: info.arriveAirport,
          tripType: this.tripType,
          departCity: info.departCity,
          arriveCity: info.arriveCity,
          useDays: info.useDays,
          vehicleTypeId: '',
          fromAddress: info.scaddress, //出发
          toAddress: info.xcaddress, //到达
          fromLat: info.sclocation.lat, // 出发纬度
          fromLon: info.sclocation.lng,
          toLat: info.xclocation.lat, //到达纬度
          toLon: info.xclocation.lng,
          useTime: info.useTime.substring(0, 16),
          flightNo: info.flightNo? info.flightNo : '' ,
          empId: this.travelerList[0].empId,
          ccsqdNo: info.Ccsqd.ccsqdNo,
          useType: 4,//接机
          customerMobile: this.travelerList[0].phoneNumber,
          customerName: this.travelerList[0].empName,
          fromLocationName: info.scdd,
          toLocationName: info.xcdd,
          departAirport:info.departAirport,
          arriveAirport:info.arriveAirport,
          departTime:info.departTime,
          arriveTime:info.arriveTime
        },
        {
          useAirportOrZd: info.departAirport ,
          arriveCity: info.arriveCity,
          departCity: info.departCity,
          fromAddress: info.scaddress,
          toAddress: info.xcaddress, //到达
          fromLat: info.sclocation.lat,
          fromLon: info.sclocation.lng,
          terminal: info.departTerminal,
          toLat: info.xclocation.lat, //到达纬度
          toLon: info.xclocation.lng,
          useTime: info.useTime.substring(0, 16),
          flightNo: info.flightNo? info.flightNo : '' ,
          tripType: this.tripType,
          empId: this.travelerList[0].empId,
          ccsqdNo: info.Ccsqd.ccsqdNo,
          useType: 5, //送机
          customerMobile: this.travelerList[0].phoneNumber,
          customerName: this.travelerList[0].empName,
          fromLocationName: info.scdd,
          toLocationName: info.xcdd,
          departAirport:info.departAirport,
          arriveAirport:info.arriveAirport,
          departTime:info.departTime,
          arriveTime:info.arriveTime
        },
        {
          useAirportOrZd: info.arriveAirport,
          arriveCity: info.arriveCity,
          fromAddress: info.scaddress,
          toAddress: info.xcaddress, //到达
          fromLat: info.sclocation.lat,
          fromLon: info.sclocation.lng,
          departCity: info.departCity,
          toLat: info.xclocation.lat, //到达纬度
          toLon: info.xclocation.lng,
          useTime: info.useTime,
          tripType: this.tripType,
          empId: this.travelerList[0].empId,
          ccsqdNo: info.Ccsqd.ccsqdNo,
          useType: 6, //接站
          customerMobile: this.travelerList[0].phoneNumber,
          customerName: this.travelerList[0].empName,
          fromLocationName: info.scdd,
          toLocationName: info.xcdd,
        },
        {
          useAirportOrZd: info.departAirport,
          fromAddress: info.scaddress,
          toAddress: info.xcaddress, //到达
          fromLat: info.sclocation.lat,
          fromLon: info.sclocation.lng,
          arriveCity: info.arriveCity,
          departCity: info.departCity,
          toLat: info.xclocation.lat, //到达纬度
          toLon: info.xclocation.lng,
          useTime: info.useTime,
          tripType: this.tripType,
          empId: this.travelerList[0].empId,
          ccsqdNo: info.Ccsqd.ccsqdNo,
          useType: 7, //送站
          customerMobile: this.travelerList[0].phoneNumber,
          customerName: this.travelerList[0].empName,
          fromLocationName: info.scdd,
          toLocationName: info.xcdd,
        },
        {
          fromAddress: info.scaddress,
          toAddress: info.xcaddress, //到达
          fromLat: info.sclocation.lat,
          fromLon: info.sclocation.lng,
          departCity: info.departCity,
          useDays: info.useDays,
          useRange: 1,
          useTime: info.useTime,
          tripType: this.tripType,
          empId: this.travelerList[0].empId,
          ccsqdNo: info.Ccsqd.ccsqdNo,
          useType: info.useDays === 0.5 ? '2' : '1', // 2半日包 1日包
          customerMobile: this.travelerList[0].phoneNumber,
          customerName: this.travelerList[0].empName,
          fromLocationName: info.scdd,
          toLocationName: info.xcdd,
        }
      ]

      this.$api['carQuery/estimateYyycPrice'](arr[info.useType])
        .then(res => {
          let cache = res.data || {}
          let typeList=cache.typeList||[]
          this.cacheId=cache.cacheId||''
          if(typeList.length==0){
            this.$dialog.alert({
              title:this.$t('C474','提示'),
              message:'未查询到符合条件的用车数据'
            })
          }
          for (let i = 0; i < typeList.length; i++) {
            typeList[i].detailBeanList.sort((x,y) => {
              return x.salePrice - y.salePrice
            })
          }

          // 如果有 订单金额上限 - 差旅匹配为不允许预订
          if (info.limitAmount) {
            typeList.forEach(types => {
              types.detailBeanList.forEach(priceDetail => {
                var limitMatch = {
                  cityLevelCode:'1',
                  clzcValue: info.limitAmount,
                  gkfs: 2,
                  sfwb: (priceDetail.salePrice + priceDetail.serviceFee) > info.limitAmount ? '1' : '0'
                }
                if (priceDetail.clzcMatch) {
                  Object.assign(priceDetail.clzcMatch, limitMatch)
                } else {
                  priceDetail.clzcMatch = limitMatch
                }
              })
            })
          }

          this.$store.commit('car/setCarList', typeList)
          this.list = typeList

        })
    },
    async book(item, info) {
      let UseAccount_DebtYck = await this.UseAccount_DebtYck
      if (!UseAccount_DebtYck) {
        this.$dialog({message: '产品未开通，如需开通产品预订请联系客服。'})
        return
      }

      if (item) this.detailBeanList = item
      if (info) this.detailBean = info

      // 差标拦截
      if (info && this.iswb(info)) {
        this.clzcStr = this.genViolateDesc(this.detailBean)
        this.$refs.violateList.toggle({ violate: this.clzcStr, cplx: '10906' }) // 选择违背原因
        return
      } else if (info && !this.canbook(info)) {
        this.clzcStr = this.genViolateDesc(this.detailBean)
        this.$toast(`当前不可预订，因违背${this.clzcStr}`)
        return
      }
      let obj = Object.assign(this.carSearchInfo, {cacheId: this.cacheId }, { info: Object.assign(this.detailBeanList, this.detailBean) })
      this.$store.commit('car/carSearchInfo', obj)
      this.$router.push({ path: '/car/carEdit' })
    },
    check(index) {
      this.$set(this.list[index], 'checked', !this.list[index].checked)
    }
  }
}
</script>

<style lang="less" scoped>
.boxfromStorn{
  // transform: translateY(50px);
  margin-bottom: 50px;
}
.carList {

  .pad-lr-6{
      padding:0 6px;
  }
  .box {
    margin-top: 5px;
  }
  .van-card {
    background-color: @color-background-white;
  }
  .van-card__content {
    min-height: auto;
  }
  .van-card__thumb {
    height: auto;
  }
  .carListwrapper {
    height: calc(100vh - 46px);
    overflow: hidden;
  }
  .p-t-15 {
    padding-top: 15px;
  }
  .pad-tb-5{
      padding: 5px 0;
  }
}
</style>
